import { render, staticRenderFns } from "./cleantask.vue?vue&type=template&id=5a02d63c&"
import script from "./cleantask.vue?vue&type=script&lang=js&"
export * from "./cleantask.vue?vue&type=script&lang=js&"
import style0 from "./cleantask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports